import dayjs from "dayjs";
import round from "lodash/round";
import { findIcon } from "../../../../dashboard/icons";

export const transformCommunityReach = (
  data = [],
  titles = ["Unique Users Cumulative", "Unique Users Per Day"],
  graphColor = ["#3256b8", "#1aa053"],
  dateFormat = "MMM DD"
) => {
  if (!Array.isArray(data)) return { series: [], labels: [] };
  return {
    series: [
      {
        name: titles.at(0),
        type: "column",
        data: data?.map((item) => item?.views),
        color: graphColor.at(0),
      },
      {
        name: titles.at(1),
        type: "line",
        data: data?.map((item) => item?.reads),
        color: graphColor.at(1),
      },
    ],
    labels: data?.map((item) => dayjs(item?.date).format(dateFormat)),
  };
};

export const transformIndiaMapData = (inputData = []) => {
  if (inputData?.length < 1) return [{}];
  const INDIA_MAP_DATA = [{}];
  inputData.forEach(({ name = "", total_count = 0 }) => {
    if (total_count === null || total_count === undefined || total_count === 0)
      return;
    INDIA_MAP_DATA[0][name] = total_count;
  });
  return INDIA_MAP_DATA;
};

export function transformSpecialityData(inputData = []) {
  const labels = [...new Set(inputData.map((item) => item.level))].sort();
  const specialityMap = {};

  inputData.forEach(({ speciality, count, level }) => {
    if (!specialityMap[speciality]) {
      specialityMap[speciality] = {
        name: speciality,
        data: Array(labels.length).fill(0),
      };
    }
    const index = labels.indexOf(level);
    if (index !== -1) {
      specialityMap[speciality].data[index] = count;
    }
  });

  return {
    series: Object.values(specialityMap),
    labels,
  };
}

export const formatNumbersCompact = (num) => {
  if (num === null || num === undefined) return "";
  if (num >= 1_000_000_000) {
    return round(num / 1_000_000_000, 1) + "B";
  } else if (num >= 1_000_000) {
    return round(num / 1_000_000, 1) + "M";
  } else if (num >= 1_000) {
    return round(num / 1_000, 1) + "K";
  }
  return num.toString();
};

export function getContentIcon(type = "") {
  switch (type?.toLowerCase()) {
    case "channel":
      return findIcon("channel", "outline", 14);

    case "medwiki":
      return findIcon("medwiki", "outline", 14);

    case "clinical_video":
      return findIcon("clinical_video", "outline", 14);

    case "training":
      return findIcon("training", "outline", 14);

    case "poll":
      return findIcon("poll", "outline", 14);

    case "live_cme":
      return findIcon("live_cme", "outline", 14);

    case "grand_round":
      return findIcon("grand_round", "outline", 14);

    case "e_book":
      return findIcon("e_book", "outline", 14);

    default:
      return findIcon("channel", "outline", 14);
  }
}
